import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProcessService } from '../../../../../service/process.service'
import { NotifierService } from 'angular-notifier';
import { GlobalSettings } from '../../../../../model/settings.model'
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],

})
export class ImageComponent extends ComponentBase implements OnInit {

  pathFile: string = this.settings.processosUrl;

  constructor(private processService: ProcessService, private settings: GlobalSettings, private notifier: NotifierService) {
    super()
  }

  ngOnInit() {
  }

  ngDelete(key: string) {
    console.log(key);
    this.processService.deleteFile(key)
  }

  onblur() { this.save(); }

  save() {
    console.log(this.attribute);
    this.processService.saveAttribute(this.attribute)
      .subscribe(() => {
        this.showNotification('default', 'Salvo');
      })
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }
}